"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reducer = require("../reducers/reducer");

var _reducer2 = _interopRequireDefault(_reducer);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _remoteAction = require("../middleware/remote-action");

var _remoteAction2 = _interopRequireDefault(_remoteAction);

var _isAuthenticatedChecker = require("../middleware/is-authenticated-checker");

var _isAuthenticatedChecker2 = _interopRequireDefault(_isAuthenticatedChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var serviceUrls = arguments[1];
  var messageLayer = arguments[2];
  var middlewareList = [_isAuthenticatedChecker2.default, _reduxThunk2.default.withExtraArgument(serviceUrls)];

  if (messageLayer) {
    middlewareList = middlewareList.concat((0, _remoteAction2.default)(messageLayer));
  }

  var store = (0, _redux.createStore)(_reducer2.default, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewareList)), window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  })); //if (module.hot) {
  //  // Enable Webpack hot module replacement for reducers
  //  module.hot.accept('../reducers', () => {
  //    const nextReducer = require('../reducers').default
  //    store.replaceReducer(nextReducer)
  //  })
  //}

  return store;
}